import { quickTags, stats } from '@/mocks/homeData';

const toneClass: Record<string, string> = {
  primary: 'border-background-50/30 bg-white/10 text-white hover:bg-white/20',
  accent: 'border-background-50/30 bg-accent-500/80 text-white hover:bg-accent-600',
  secondary: 'border-background-50/30 bg-white/10 text-white hover:bg-white/20',
};

const toneIcon: Record<string, string> = {
  primary: 'text-secondary-200',
  accent: 'text-accent-200',
  secondary: 'text-secondary-100',
};

export default function Hero() {
  return (
    <section id="top" className="relative min-h-[640px] w-full overflow-hidden md:min-h-[720px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20editorial%20media%20aggregator%20collage%20with%20floating%20news%20cards%20search%20bars%20and%20topic%20tag%20chips%2C%20warm%20coral%20orange%20and%20amber%20gradient%20background%2C%20modern%20flat%20vector%20illustration%2C%20soft%20glow%2C%20clean%20composition%2C%20no%20text&width=1800&height=950&seq=hero-91free-2026&orientation=landscape"
          alt="91免费精选合集 91免费内容包 内容聚合背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/45 to-background-50" />
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-24 pt-36 text-center md:px-6 md:pt-44">
        <span className="animate-fade-up inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-white/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur md:text-sm">
          <i className="ri-flashlight-fill text-secondary-200" />
          今日已更新精选合集 · 瓜料热榜同步滚动
        </span>

        <h1 className="animate-fade-up mt-7 max-w-4xl leading-tight" style={{ animationDelay: '0.05s' }}>
          <span className="font-heading block text-7xl tracking-wide text-white drop-shadow-sm md:text-[9rem] md:leading-none">
            91<span className="text-secondary-300">免费</span>
          </span>
          <span className="mt-3 block font-heading text-xl tracking-[0.18em] text-background-50 md:text-2xl">
            精选合集 · 内容包 · 瓜料汇总
          </span>
        </h1>

        <p
          className="animate-fade-up mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-background-50/85 md:text-base"
          style={{ animationDelay: '0.12s' }}
        >
          把散落各处的热门内容整理成 91免费精选合集与 91免费内容包：瓜料汇总、内容大全、素材库一次摆齐，
          按标签筛、按热度收，点开即可浏览收藏。
        </p>

        <div
          className="animate-fade-up mt-8 flex w-full flex-col items-center gap-3 sm:flex-row sm:justify-center"
          style={{ animationDelay: '0.18s' }}
        >
          <a
            href="#collections"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-box-3-fill text-base" /> 浏览精选合集
          </a>
          <a
            href="#hot"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-background-50/40 bg-white/10 px-7 py-3.5 text-sm font-semibold text-white backdrop-blur transition-colors hover:bg-white/20 sm:w-auto"
          >
            <i className="ri-fire-fill text-base text-accent-300" /> 查看瓜料热榜
          </a>
        </div>

        <div
          className="animate-fade-up mt-10 flex w-full flex-wrap items-center justify-center gap-2.5 md:gap-3"
          style={{ animationDelay: '0.24s' }}
        >
          {quickTags.map((tag) => (
            <a
              key={tag.label}
              href="#topics"
              className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-4 py-1.5 text-xs font-medium backdrop-blur transition-colors md:text-sm ${toneClass[tag.tone]}`}
            >
              <i className={`text-sm ${toneIcon[tag.tone]}`} />
              {tag.label}
            </a>
          ))}
        </div>

        <div
          className="animate-fade-up mt-14 grid w-full max-w-3xl grid-cols-2 gap-3 md:grid-cols-4 md:gap-4"
          style={{ animationDelay: '0.3s' }}
        >
          {stats.map((item) => (
            <div
              key={item.label}
              className="rounded-xl border border-background-50/15 bg-white/5 px-3 py-4 backdrop-blur"
            >
              <p className="font-heading text-2xl text-background-50 md:text-3xl">{item.value}</p>
              <p className="mt-1 text-xs text-background-50/70">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}